import React, { FC, useState, useEffect } from 'react'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { TitleOnBoarding } from '../../../components/TitleOnBoarding'
import { launchWebSdk } from '../../../utils/launchWebSdk'
import { useRest } from '../../../components/Context'
import { AccountType } from '../../../constants/accountType'

const useStyles = makeStyles({
  root: {
    margin: '0 auto',
    maxWidth: 1184,
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 'bold',
  },
  container: {
    width: '632px',
    marginTop: '81px',
  },
  sumsub: {
    width: '100%',
  },
})

export const SumSubstance: FC = () => {
  const classes = useStyles()
  const history = useHistory()
  const [activeStep] = useState(9)
  const { rxios } = useRest()
  const location = useLocation()
  const { uniqKey } = useParams() as { [key: string]: string }

  useEffect(() => {
    const statusSumSub = ['init', 'pending', 'completed']
    rxios
      .post(`user/onboarding/sum-sub`, {
        hash: uniqKey,
      })
      .subscribe(
        // eslint-disable-next-line
        async (next: any) => {
          const { accessToken, apiUrl } = next
          const {
            payload: { reviewStatus },
          }: // eslint-disable-next-line
          any = await launchWebSdk('#sumsub-websdk-container', apiUrl, accessToken)

          if (statusSumSub.includes(reviewStatus)) {
            rxios
              .post('user/onboarding/sum-sub/account-Type', {
                hash: uniqKey,
              })
              .subscribe(
                // eslint-disable-next-line
                (next: any) => {
                  const url = next.accountType === AccountType.COMPANY ? AccountType.COMPANY : 'user'
                  rxios.post(`${url}/onboarding/finish/${uniqKey}`, {}).subscribe(
                    () => {
                      history.push({
                        ...location,
                        state: {
                          activeStep,
                        },
                      })
                    },
                    () => {
                      toast.error('Verified Error')
                    },
                  )
                },
                (error) => {
                  toast.error(error.response.data.message)
                },
              )
          }
        },
        // eslint-disable-next-line
        (error) => {
          toast.error('Verified Error')
        },
      )
  }, [location, rxios, uniqKey, history, activeStep])

  return (
    <Grid className={classes.root} container direction="column" alignItems="center">
      <TitleOnBoarding leftArrow activeStep={activeStep} />
      <Grid item container className={classes.container} direction="column" alignItems={'center'}>
        <div id="sumsub-websdk-container" className={classes.sumsub} />
      </Grid>
    </Grid>
  )
}
